/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IPaymentTransactionMethods,
  PaymentTransactionService,
  DeleteDraftService,
  IDeleteDraftMethods,
  IPaymentTxnReportMethods,
  PaymentTxnReportService
} from './plugins';

export type PaymentTransactionAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IPaymentTransactionMethods &
  IDeleteDraftMethods &
  IPaymentTxnReportMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new PaymentTransactionService(),
    new DeleteDraftService(),
    new PaymentTxnReportService()
  ];
};

export const getAgent = () => {
  return createAgent<PaymentTransactionAgent>({
    plugins: getPlugins(),
  });
};
